import { useEffect } from "react";

const SITE = "https://solvedesk.space";

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("meta[property") ? "meta" : "meta");
    const match = selector.match(/\[(?:property|name)="([^"]+)"\]/);
    if (match) {
      el.setAttribute(selector.includes("property") ? "property" : "name", match[1]);
    }
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function Seo({ title, description, path = "/", image = "/og-image.jpg" }) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    const img = `${SITE}${image}`;
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", img);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", img);
  }, [title, description, path, image]);
  return null;
}
